export class ReportGeneratorTemplate {
  templateId: string;
  name: string;
  useName: string;
}
